export default "__VITE_ASSET__XkoF7BSSbncKX_yOJhf3Ow__"